var map = {
	"./pin-098CB3.png": 16,
	"./pin-5FBCA2.png": 17,
	"./pin-E8ADC7.png": 18,
	"./pin-blue.png": 19,
	"./pin-green.png": 20,
	"./pin-hover.png": 21,
	"./pin-navy.png": 22,
	"./pin-orange.png": 23,
	"./pin-purple.png": 24
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 126;